
import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from 'react-redux';
import BootstrapTable from 'react-bootstrap-table-next';
import ToolkitProvider from 'react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit.min';
import { Button, Spinner } from 'react-bootstrap';
import { Auth, LoadingComponent } from 'recupero-comunes'
import 'recupero-comunes/dist/index.css'
import { Card, OverlayTrigger, Tooltip } from "react-bootstrap";
import { obtenerConsultaCasos, obtenerExcel } from "../../store/actions/are-busqueda-casos-action";
import { obtenerTareasPendientes } from "../../store/actions/administracion-caso-action";
import { useNavigate } from 'react-router-dom'

import VisaProvisionesModal from './visar-provision';
import CierreMoldal from "./confirmar-cierre";
import AutorizarInformeProfesional from "./autorizar-informe-profesional";
import AutorizarReservaModal from "./visar-provision/autorizarReserva"
import AtenderAumentoConciliar from "./atender-aumento-conciliar"
import AsignarAbogado from "./asignar-abogado"
import RevisarInformePenal from "./revisar-informe-penal"
import { ID_TAREA_VISAR_ACTUALIZACION, ID_TAREA_VISAR_INFORME_INICIAL } from "./revisar-informe-penal/constantes"

// Espera entre recargas automáticas mientras el WFL (asíncrono, vía SNS) aún no retira una
// tarea recién gestionada de la grilla. Al agotarse, la fila sigue bloqueada y el usuario
// puede verificar con el botón "Actualizar".
const ESPERAS_AUTOREFRESCO_MS = [3000, 6000, 10000, 15000];

const GrillaTareasPendientes = () => {
    const dispatch = useDispatch();
    const history = useNavigate()

    const data_admnistracion = useSelector((state) => state.administracionCasoReducer);
    const { cfg_form43, listaTareasPendientes } = data_admnistracion;

    const data_encargado = useSelector((state) => state.encargadoCompaniaReducer);
    const { llaves } = data_encargado;

    const [loading, setLoading] = useState(false);
    const [listaGrilla, setListaGrilla] = useState('');

    const [action, setAction] = useState("");
    const [actionCierre, setActionCierre] = useState("");
    const [showVisarProvision, setShowVisarProvision] = useState(false);
    const [implicadoSeleccionado, setImplicadoSeleccionado] = useState("");
    const [origenVisar, setOrigenVisar] = useState("");

    const [showCierre, setShowCierre] = useState(false);
    const [idSolicitudInforme, setIdSolicitudInforme] = useState("");
    const [idTrxOrigen, setIdTrxOrigen] = useState("");
    const [idProcesoJud, setIdProcesoJud] = useState("");
    const [showAutorizar, setShowAutorizar] = useState(false);
    const [showAutorizarReserva, setShowAutorizarReserva] = useState(false);
    const [secuenciaInforme, setSecuenciaInforme] = useState("");
    const [showAtenderAumento, setShowAtenderAumento] = useState(false);
    const [idSolGestion, setIdSolGestion] = useState("");
    const [showAsignarAbogado, setShowAsignarAbogado] = useState(false);
    const [filaAsignarAbogado, setFilaAsignarAbogado] = useState(null);
    const [showRevisarInforme, setShowRevisarInforme] = useState(false);

    // idTrxOrigen (wcs_int_trxSalida) de tareas ya gestionadas que el WFL todavía no retira de
    // la grilla. Estado local a propósito: se descarta al salir de la pantalla y el servidor
    // vuelve a ser la fuente de verdad.
    const [tareasEnProceso, setTareasEnProceso] = useState([]);
    const [intentosAutoRefresco, setIntentosAutoRefresco] = useState(0);

    useEffect(() => {
        setListaGrilla(listaTareasPendientes && listaTareasPendientes.listaTareasPendientes)
    }, [listaTareasPendientes])

    // Auto-poda: solo se conservan los ids que el servidor aún devuelve. Si la recarga falló
    // (no hay lista) no se toca nada, para no desbloquear por error.
    useEffect(() => {
        if (!Array.isArray(listaGrilla)) return;
        const vigentes = new Set(listaGrilla.map((t) => Number(t.idTrxOrigen)));
        setTareasEnProceso((prev) => {
            const siguiente = prev.filter((id) => vigentes.has(id));
            return siguiente.length === prev.length ? prev : siguiente;
        });
    }, [listaGrilla]);

    // Auto-refresco con espera creciente mientras haya tareas en proceso.
    useEffect(() => {
        if (tareasEnProceso.length === 0) {
            if (intentosAutoRefresco !== 0) setIntentosAutoRefresco(0);
            return undefined;
        }
        if (intentosAutoRefresco >= ESPERAS_AUTOREFRESCO_MS.length) return undefined;
        const timer = setTimeout(() => {
            recargarTareasPendientes();
            setIntentosAutoRefresco((n) => n + 1);
        }, ESPERAS_AUTOREFRESCO_MS[intentosAutoRefresco]);
        return () => clearTimeout(timer);
    }, [tareasEnProceso, intentosAutoRefresco]);

    const handleReload = () => {
        if (consultaCasos && consultaCasos.query) {
            setLoading(true);

            // Obtener última query enviada
            let query = consultaCasos.query;

            // Ejecutar acción para obtener casos.
            dispatch(obtenerConsultaCasos(query)).then(() => {
                setLoading(false);
            });
        }
    }

    const recargarTareasPendientes = () => {
        let query = Buffer.from(JSON.stringify({ idCaso: llaves?.idCaso, idUsuario: Auth.currentUser().rutUsuario })).toString('base64');
        dispatch(obtenerTareasPendientes(query));
    }

    // Los modales la invocan solo cuando la gestión terminó con éxito (code === 1). Orden
    // obligatorio: primero marcar y después recargar; si no, una respuesta rápida pasaría por
    // la auto-poda sin la marca y el botón quedaría habilitado.
    const onTareaGestionada = () => {
        const idTrx = Number(idTrxOrigen);
        if (idTrx) {
            setTareasEnProceso((prev) => (prev.includes(idTrx) ? prev : [...prev, idTrx]));
            setIntentosAutoRefresco(0);
        }
        recargarTareasPendientes();
    }

    const onClick = (row) => {
        setIdTrxOrigen(row.idTrxOrigen);
        if (row.idTarea == 15) {//Iniciar Gestión Defensa Penal -> Asignar Abogado (RG-565)
            setFilaAsignarAbogado(row);
            setShowAsignarAbogado(true);
        } else if (row.idTarea == ID_TAREA_VISAR_INFORME_INICIAL || row.idTarea == ID_TAREA_VISAR_ACTUALIZACION) {//Visar informe de defensa penal (RG-580)
            setShowRevisarInforme(true);
        } else if (row.idTarea == 86) {//Atender Solicitud Aumento Monto a Conciliar
            setImplicadoSeleccionado(row.idImplicado);
            setIdSolGestion(row.idSolGestion);
            setShowAtenderAumento(true);
        } else if (row.idTarea == 81) {//Autorizar informe Profesional
            setIdSolicitudInforme(row.idSolInforme);
            setShowAutorizar(true);
        } else if (row.idTarea == 27) {//Autorizar Reserva
            setAction('valpec');
            setImplicadoSeleccionado(row.idImplicado);
            setOrigenVisar(row.idTarea);
            setSecuenciaInforme(row.secInforme);
            setShowAutorizarReserva(true);
        } else {
            let action = (row.idTarea == 26 || row.idTarea == 28) ? 'provision' : 'valpec';
            let actionCierre = (row.idTarea == 32 || row.idTarea == 33) ? 'confcierre' : 'rechcierre';

            setAction(action);
            setActionCierre(actionCierre);
            setImplicadoSeleccionado(row.idImplicado);
            setOrigenVisar(row.idTarea);

            if (row.idTarea === 31 || row.idTarea === 32 || row.idTarea === 33) { setIdProcesoJud(row.idProcesoJud); setShowCierre(true); }
            else setShowVisarProvision(true);
        }
    };

    const obtenerColumnas = () => {
        return [
            {
                dataField: 'tarea', text: cfg_form43 ? cfg_form43.cfg_form43['formbasegestiondefensacia-grilla-tareas-pend-tarea'] : '', sort: false, headerAlign: 'center', align: 'center',
                headerFormatter: (column, colIndex, { sortElement, filterElement }) => (<div>{column.text}<br />{sortElement}</div>)
                , headerStyle: { color: 'white', backgroundColor: '#7594C1' }
            },
            {
                dataField: 'fecAsigTareaFormat', text: cfg_form43 ? cfg_form43.cfg_form43['formbasegestiondefensacia-grilla-tareas-pend-fecta'] : '',
                sort: false,
                sortFunc: (a, b, order, dataField, rowA, rowB) => {
                    if (order === 'asc') return stringDate2Time(a) - stringDate2Time(b);
                    else return stringDate2Time(b) - stringDate2Time(a);
                },
                headerAlign: 'center', align: 'center',
                headerFormatter: (column, colIndex, { sortElement, filterElement }) => (<div>{column.text}<br />{sortElement}</div>)
                , headerStyle: { color: 'white', backgroundColor: '#7594C1' }
            },
            {
                dataField: 'implicado', text: cfg_form43 ? cfg_form43.cfg_form43['formbasegestiondefensacia-grilla-tareas-pend-nomim'] : '', sort: false, headerAlign: 'center', align: 'center',
                headerFormatter: (column, colIndex, { sortElement, filterElement }) => (<div>{column.text}<br />{sortElement}</div>)
                , headerStyle: { color: 'white', backgroundColor: '#7594C1' }
            },
            {
                dataField: 'patente', text: cfg_form43 ? cfg_form43.cfg_form43['formbasegestiondefensacia-grilla-tareas-pend-paten'] : '', sort: false, headerAlign: 'center', align: 'center',
                headerFormatter: (column, colIndex, { sortElement, filterElement }) => (<div>{column.text}<br />{sortElement}</div>)
                , headerStyle: { color: 'white', backgroundColor: '#7594C1' }
            },
            {
                dataField: 'ultHito', text: cfg_form43 ? cfg_form43.cfg_form43['formbasegestiondefensacia-grilla-tareas-pend-ulthi'] : '', sort: false, headerAlign: 'center', align: 'center',
                headerFormatter: (column, colIndex, { sortElement, filterElement }) => (<div>{column.text}<br />{sortElement}</div>)
                , headerStyle: { color: 'white', backgroundColor: '#7594C1' }
            },
            {
                dataField: 'fecIngHitoFormat', text: cfg_form43 ? cfg_form43.cfg_form43['formbasegestiondefensacia-grilla-tareas-pend-fechi'] : '',
                sort: false,
                sortFunc: (a, b, order, dataField, rowA, rowB) => {
                    if (order === 'asc') return stringDate2Time(a) - stringDate2Time(b);
                    else return stringDate2Time(b) - stringDate2Time(a);
                },
                headerAlign: 'center', align: 'center',
                headerFormatter: (column, colIndex, { sortElement, filterElement }) => (<div>{column.text}<br />{sortElement}</div>)
                , headerStyle: { color: 'white', backgroundColor: '#7594C1' }
            },
            {
                dataField: 'accion', text: cfg_form43 ? cfg_form43.cfg_form43['formbasegestiondefensacia-grilla-tareas-pend-accio'] : '', isDummyField: true, headerAlign: 'center', align: 'center',
                headerStyle: { color: 'white', backgroundColor: '#7594C1', verticalAlign: 'middle' },
                // La celda solo se repinta si cambia formatExtraData (react-bootstrap-table-next
                // no observa el estado externo del componente).
                formatExtraData: { tareasEnProceso, autoRefrescoAgotado: intentosAutoRefresco >= ESPERAS_AUTOREFRESCO_MS.length },
                formatter: (cell, row, rowIndex, extra) => {
                    return accionGestionTarea(row, extra);
                }
            }
        ];
    }

    const accionGestionTarea = (row, extra) => {
        if (row.indAccedeTarea == 1 && extra?.tareasEnProceso?.includes(Number(row.idTrxOrigen))) {
            const mensaje = extra.autoRefrescoAgotado
                ? 'Tarea gestionada. El flujo aún no la actualiza: usa "Actualizar" para verificar.'
                : 'Tarea gestionada, esperando actualización del flujo…';
            return <div>
                <OverlayTrigger overlay={<Tooltip id='tooltip-en-proceso'>{mensaje}</Tooltip>}>
                    <span className="d-inline-block">
                        <Button type="button" variant="outline-secondary me-md-2" size="sm" disabled style={{ pointerEvents: 'none' }}>
                            {extra.autoRefrescoAgotado
                                ? <span aria-hidden="true">…</span>
                                : <Spinner animation="border" size="sm" />}
                        </Button>
                    </span>
                </OverlayTrigger>
            </div>
        }
        if (row.indAccedeTarea == 1) {
            let glosa = row.idTarea == 15 ? "Asignar Abogado" : (row.idTarea == ID_TAREA_VISAR_INFORME_INICIAL || row.idTarea == ID_TAREA_VISAR_ACTUALIZACION) ? "Visar Informe Penal" : (row.idTarea == 26 || row.idTarea == 27 || row.idTarea == 28) ? "Provisiones" : (row.idTarea == 31 || row.idTarea == 32 || row.idTarea == 33) ? "Confirmar Cierre" : row.idTarea == 81 ? "Autorizar Informe Profesional" : row.idTarea == 86 ? "Atender Aumento Monto a Conciliar" : "Propuesta Indemnización";
            return <div>
                <OverlayTrigger overlay={<Tooltip id='tooltip-disabled'>Ver {glosa} </Tooltip>}>
                    <Button type="button" variant="outline-secondary me-md-2" size="sm" onClick={() => onClick(row)}>
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-gear-fill" viewBox="0 0 16 16">
                            <path d="M9.405 1.05c-.413-1.4-2.397-1.4-2.81 0l-.1.34a1.464 1.464 0 0 1-2.105.872l-.31-.17c-1.283-.698-2.686.705-1.987 1.987l.169.311c.446.82.023 1.841-.872 2.105l-.34.1c-1.4.413-1.4 2.397 0 2.81l.34.1a1.464 1.464 0 0 1 .872 2.105l-.17.31c-.698 1.283.705 2.686 1.987 1.987l.311-.169a1.464 1.464 0 0 1 2.105.872l.1.34c.413 1.4 2.397 1.4 2.81 0l.1-.34a1.464 1.464 0 0 1 2.105-.872l.31.17c1.283.698 2.686-.705 1.987-1.987l-.169-.311a1.464 1.464 0 0 1 .872-2.105l.34-.1c1.4-.413 1.4-2.397 0-2.81l-.34-.1a1.464 1.464 0 0 1-.872-2.105l.17-.31c.698-1.283-.705-2.686-1.987-1.987l-.311.169a1.464 1.464 0 0 1-2.105-.872l-.1-.34zM8 10.93a2.929 2.929 0 1 1 0-5.86 2.929 2.929 0 0 1 0 5.858z" />
                        </svg>
                    </Button>
                </OverlayTrigger>
            </div>
        } else {
            return <div></div>
        }
    }

    const stringDate2Time = (date) => {
        date = date.split("-");
        return new Date(date[2], date[1] - 1, date[0]).getTime();
    }

    return (
        <div>
            <style type='text/css'>
                {`
                    .btn-subir {
                    background-color: #00aeab;
                    color: #FFFFFF;   
                    height:40px;

                    }
                    .btn-subir:hover{
                        background-color:#01cec8;
                        color: #FFFFFF;
                        
                    } 
                    .customCard {
                        padding-top: 0;
                        padding-left: 0;
                        padding-right: 0;
                    }
                    
                    .customTable > thead {
                        color: white; 
                        background-color: rgb(114, 139, 176);
                    }
                    
                    .customTable > thead > tr > th {
                        padding: 20px 0;
                    }
                    
                    .customResponsive {
                        overflow-x: auto;
                        height: 240px !important;
                    }
                `}
            </style>

            <AsignarAbogado
                showModal={showAsignarAbogado}
                setShowModal={setShowAsignarAbogado}
                row={filaAsignarAbogado}
                onTareaGestionada={onTareaGestionada}
            />
            <RevisarInformePenal
                showModal={showRevisarInforme}
                setShowModal={setShowRevisarInforme}
                onTareaGestionada={onTareaGestionada}
            />
            <VisaProvisionesModal
                action={action}
                showModal={showVisarProvision}
                setShowModal={setShowVisarProvision}
                implicado={implicadoSeleccionado}
                origenVisar={origenVisar}
                idTrxOrigen={idTrxOrigen}
                onTareaGestionada={onTareaGestionada}
            />
            <AutorizarReservaModal
                action={action}
                showModal={showAutorizarReserva}
                setShowModal={setShowAutorizarReserva}
                implicado={implicadoSeleccionado}
                origenVisar={origenVisar}
                idTrxOrigen={idTrxOrigen}
                secuenciaInforme={secuenciaInforme}
                onTareaGestionada={onTareaGestionada}
            />

            <CierreMoldal
                action={actionCierre}
                showModal={showCierre}
                setShowModal={setShowCierre}
                implicado={implicadoSeleccionado}
                idTrxOrigen={idTrxOrigen}
                idProcesoJud={idProcesoJud}
                onTareaGestionada={onTareaGestionada}
            />
            <AutorizarInformeProfesional
                showModal={showAutorizar}
                setShowModal={setShowAutorizar}
                idSolicitudInforme={idSolicitudInforme}
                idTrxOrigen={idTrxOrigen}
                onTareaGestionada={onTareaGestionada}
            />
            <AtenderAumentoConciliar
                showModal={showAtenderAumento}
                setShowModal={setShowAtenderAumento}
                implicado={implicadoSeleccionado}
                idSolGestion={idSolGestion}
                idTrxOrigen={idTrxOrigen}
                onTareaGestionada={onTareaGestionada}
            />

            <LoadingComponent show={loading} />
            {cfg_form43 ?
                <Card >
                    {/*<Card.Header className='mt-0 mb-0' as='h6' style={{ backgroundColor: '#4F517A', color: 'white', textAlign:'center' }}>
                {cfg_form43
                    ? `${cfg_form43.cfg_form43['formbasegestiondefensacia-title-tareas-pend']}`
                    : ''} 
                </Card.Header>
                <Card.Body variant='customCard'>
                    <Table striped variant='customTable'>
                        <thead>
                            <tr>
                                <th style={{ textAlign: 'center' }}>{cfg_form43 ? cfg_form43.cfg_form43['formbasegestiondefensacia-grilla-tareas-pend-tarea']:''}</th>
                                <th style={{ textAlign: 'center' }}>{cfg_form43 ? cfg_form43.cfg_form43['formbasegestiondefensacia-grilla-tareas-pend-fecta']:''}</th>
                                <th style={{ textAlign: 'center' }}>{cfg_form43 ? cfg_form43.cfg_form43['formbasegestiondefensacia-grilla-tareas-pend-nomim']:''}</th>
                                <th style={{ textAlign: 'center' }}>{cfg_form43 ? cfg_form43.cfg_form43['formbasegestiondefensacia-grilla-tareas-pend-paten']:''}</th>
                                <th style={{ textAlign: 'center' }}>{cfg_form43 ? cfg_form43.cfg_form43['formbasegestiondefensacia-grilla-tareas-pend-ulthi']:''}</th>
                                <th style={{ textAlign: 'center' }}>{cfg_form43 ? cfg_form43.cfg_form43['formbasegestiondefensacia-grilla-tareas-pend-fechi']:''}</th>
                                <th style={{ textAlign: 'center' }}>{cfg_form43 ? cfg_form43.cfg_form43['formbasegestiondefensacia-grilla-tareas-pend-accio']:''}</th>
                            </tr>
                        </thead>
                        <tbody>
                            {listaGrilla && listaGrilla.map((tarea, index) => (
                                <tr key={index}>                        
                                    <td style={{ textAlign: 'center' }}>{tarea.tarea}</td>
                                    <td style={{ textAlign: 'center' }}>{tarea.fecAsigTareaFormat}</td>
                                    <td style={{ textAlign: 'center' }}>{tarea.implicado}</td>
                                    <td style={{ textAlign: 'center' }}>{tarea.patente}</td>
                                    <td style={{ textAlign: 'center' }}>{tarea.ultHito}</td>
                                    <td style={{ textAlign: 'center' }}>{tarea.fecIngHitoFormat}</td>
                                    <td style={{ textAlign: 'center' }}>

                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </Table>
                </Card.Body>
            */}
                    <ToolkitProvider search bootstrap4 keyField="Id"
                        data={listaGrilla ? listaGrilla : []}
                        columns={obtenerColumnas()} defaultSorted={[{ dataField: 'Id', order: 'asc' }]}>
                        {
                            props =>
                                <div>
                                    <BootstrapTable {...props.baseProps} headerWrapperClasses="table-secondary" noDataIndication={<div className="text-center">No hay registros encontrados</div>} />
                                </div>
                        }
                    </ToolkitProvider>

                </Card>

                : null}
        </div>
    );
}

export default GrillaTareasPendientes;
